module.exports = __webpack_public_path__ + "animated_arrows_pointing_bottom.a465d34.gif";